import React from 'react';
import Mascot from '../components/mascot-render/mascot';
export const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
};
export const renderMascot = (percentQuiz, height = '350px', width = '200px') => {
    let imageName;
    switch (true) {
        case percentQuiz >= 90 && percentQuiz <= 100:
            imageName = 'jumpingBull';
            break;
        case percentQuiz >= 80 && percentQuiz <= 89:
            imageName = 'jumpingBull';
            break;
        case percentQuiz >= 70 && percentQuiz <= 79:
            imageName = 'scratchitHead';
            break;
        case percentQuiz >= 60 && percentQuiz <= 69:
            imageName = 'sadBull'; // Use the same image for D and F but could be adjusted if there were two different images
            break;
        case percentQuiz < 60:
            imageName = 'sadBull';
            break;
        default:
            imageName = 'fistPumBull';
            break;
    }
    return React.createElement(Mascot, { type: imageName, height: height, width: width });
};
export const isNullOrInvalidString = (param) => {
    return param === null || param === undefined || param === '' || param === 'null' || param === 'undefined';
};
export const stringCompare = (string1, string2) => {
    var _a, _b, _c, _d;
    if (isNullOrInvalidString(string1) || isNullOrInvalidString(string2))
        return false;
    const formattedStatement = (_b = (_a = string1 === null || string1 === void 0 ? void 0 : string1.toString()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.replace(/\s+/g, '');
    const formattedUserInput = (_d = (_c = string2 === null || string2 === void 0 ? void 0 : string2.toString()) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === null || _d === void 0 ? void 0 : _d.replace(/\s+/g, '');
    // Comparar ambos valores formateados
    return formattedStatement === formattedUserInput;
};
